import { defineStore } from "pinia";
import vuetify from "@/plugins/vuetify";

export const useUiStore = defineStore("auth", {
  state: () => ({
    loading: false,
    globalLoading: false,

    theme: "light",

    notification: {
      visible: false,
      message: "",
      type: "",
      timeout: 3000,
    },

    confirm: {
      visible: false,
      title: "Confirm",
      message: "Are you sure?",
      confirmText: "Yes",
      cancelText: "No",
      resolve: null,
      reject: null,
    },

    midScreenDialog: {
      title: "Dialog",
      subtitle: "",
      value: null,
      isOpened: false,
    },
  }),

  actions: {
    startLoading() {
      this.loading = true;
    },

    stopLoading() {
      this.loading = false;
    },

    startGlobalLoading() {
      this.globalLoading = true;
    },

    stopGlobalLoading() {
      this.globalLoading = false;
    },

    applyTheme(color = null) {
      const savedTheme = localStorage.getItem("theme") || "light";
      const savedColor = localStorage.getItem("primaryColor") || "#363740";

      this.theme = savedTheme;
      vuetify.theme.global.name.value = savedTheme;

      if (savedTheme === "dark") return;

      const primary = color || savedColor;
      vuetify.theme.themes.value.light.colors.primary = primary;
      this.primaryColor = primary;
      localStorage.setItem("primaryColor", primary);
    },

    setTheme(value) {
      this.theme = value;
      localStorage.setItem("theme", value);
      vuetify.theme.global.name.value = value;

      if (value === "light") {
        const savedColor = localStorage.getItem("primaryColor") || "#363740";
        vuetify.theme.themes.value.light.colors.primary = savedColor;
      }
    },

    showNotification(message, type = "success", timeout = 3000) {
      this.notification.message = message;
      this.notification.timeout = timeout;
      this.notification.type = type;
      this.notification.visible = true;
      setTimeout(() => {
        this.notification.visible = false;
      }, timeout);
    },
    showConfirm({title = "Confirm",message = "Are you sure?",confirmText = "Yes",cancelText = "No"} = {}) {
      this.confirm.title = title;
      this.confirm.message = message;
      this.confirm.confirmText = confirmText;
      this.confirm.cancelText = cancelText;
      this.confirm.visible = true;

      return new Promise((resolve, reject) => {
        this.confirm.resolve = () => {
          resolve(true);
          this.confirm.visible = false;
        };
        this.confirm.reject = () => {
          reject(false);
          this.confirm.visible = false;
        };
      });
    },
    openMidDialog(title = "Dialog", subtitle = "", payload = null, key = null) {
      this.midScreenDialog.title = title;
      this.midScreenDialog.subtitle = subtitle;
      this.midScreenDialog.value = payload;
      this.midScreenDialog.isOpened = true;
      this.midScreenDialog.key = key;
    },
    closeMidDialog() {
      this.midScreenDialog.isOpened = false;
    },
  },

  getters: {
    getLoading: (state) => state.loading,
    getGlobalLoading: (state) => state.globalLoading,
    getTheme: (state) => state.theme,
    getNotification: (state) => state.notification,
    getConfirm: (state) => state.confirm,
    getMidDialog: (state) => state.midScreenDialog,
  },
});
